import { combineReducers } from 'redux';
import portfolioReducer from './portfolioReducer';
import appReducer from './appReducer';
import backupReducer from './backupReducer';
import settingsReducer from './settingsReducer';

const reducer = combineReducers({
  portfolioReducer,
  appReducer,
  backupReducer,
  settingsReducer,
});

const rootReducer = (state, action) => {
  if (action.type === 'IMPORT_DATA') {
    return {
      ...state,
      backupReducer: backupReducer(state.backupReducer, {
        type: 'ADD_BACKUP',
        date: action.date,
        data: { portfolioReducer: state.portfolioReducer },
      }),
      ...action.data,
    };
  }

  return reducer(state, action);
};

export default rootReducer;
